import React, { useEffect } from 'react';
import PropTypes from "prop-types"
import ReactModal from 'react-modal';

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

const Layout = ({ siteMetadata, children }) => {
  useEffect(() => {
    ReactModal.setAppElement("#layout");
  }, [])

  return (
    <div id="layout" className="flex flex-col min-h-screen">
      <Header siteTitle={siteMetadata.title} />
      <main className="flex-grow">{children}</main>
      <Footer siteTitle={siteMetadata.title} />
    </div>
  )
}

Layout.propTypes = {
  siteMetadata: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default Layout
